/**
 * Sol per-flavour panel.
 *
 * Wraps content that belongs to one variant, such as a nutrition panel. The
 * page renders the right one for the selected variant; this swaps them when
 * the shopper changes flavour. Horizon morphs only the variant picker, so
 * everything else has to listen for productSelect, as product-sku.js does.
 * The event bubbles to document, which is how a panel outside the product
 * section still hears it.
 */
import { StandardEvents } from '@shopify/events';

class SolVariantPanel extends HTMLElement {
  connectedCallback() {
    document.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        const variant = detail?.resource;
        if (!variant) return;
        if (detail.productId && String(detail.productId) !== this.dataset.productId) return;

        const options = variant.options ?? [variant.title];
        this.hidden = !options.includes(this.dataset.flavour);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[sol-variant-panel] promise rejected:', error);
      });
  };
}

if (!customElements.get('sol-variant-panel')) {
  customElements.define('sol-variant-panel', SolVariantPanel);
}
